import { useDebouncedCallback } from "@react-hookz/web";
import { useAtom } from "jotai";
import { useEffect } from "react";

import { isDocumentBodyScrollLockedAtom } from "./atoms";

export const useDocumentBodyScrollLock = () => {
  const [isDocumentBodyScrollLocked, setIsDocumentBodyScrollLocked] = useAtom(
    isDocumentBodyScrollLockedAtom,
  );

  useEffect(() => {
    window.document.body.style.overflowY = isDocumentBodyScrollLocked ? "hidden" : "auto";
  }, [isDocumentBodyScrollLocked]);

  const lockDocumentBodyScroll = useDebouncedCallback(
    (lock: boolean) => {
      setIsDocumentBodyScrollLocked(lock);
    },
    [],
    100,
  );

  return { lockDocumentBodyScroll };
};
